import classes from "./NewUserModalBackdrop.module.css";

function NewUserModalBackdrop(props) {
    return <div
        className={classes.newUserModalBackdrop_backdropDiv}
        onClick={() => {
            props.setShowNewUserModal(false);
        }}
    />
}

export default NewUserModalBackdrop;
